<template>
  <div class="w-full">
    <content-placeholders class="w-full" v-if="isLoading">
      <ul
        class="grid md:grid-cols-3 gap-4 w-full"
        :class="expandMobileFilter ? 'grid-cols-1 sm:grid-cols-2' : 'grid-cols-2'"
      >
        <li v-for="i in 10" :key="i">
          <div class="h-80 rounded-lg overflow-hidden">
            <content-placeholders-img animated style="height: 100%" />
          </div>
        </li>
      </ul>
    </content-placeholders>
    <Transition name="fade">
      <div v-if="!isLoading">
        <TransitionGroup
          name="list"
          tag="ul"
          class="grid md:grid-cols-3 gap-4"
          :class="expandMobileFilter ? 'grid-cols-1 sm:grid-cols-2' : 'grid-cols-2'"
        >
          <li v-for="product in filteredProducts" :key="product.id">
            <a :href="SITE_BASE_URL + product.bloggerPageUrl">
              <div class="h-60 md:h-80 rounded-lg overflow-clip">
                <img
                  v-lazy="product.metadata.image"
                  class="object-cover h-80 hover:scale-125 w-full transition-transform duration-700"
                />
              </div>
            </a>
          </li>
        </TransitionGroup>
      </div>
    </Transition>
  </div>
</template>

<script>
import UTDService from "@/services/UTDService";
import { SITE_BASE_URL } from "@/constants/urls";

export default {
  name: "ProductGrid",
  props: {
    page: String,
    filters: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      products: [],
      isLoading: true,
      SITE_BASE_URL,
    };
  },
  inject: ["getIsExpandedMobileFilter"],
  methods: {
    async getProducts() {
      this.isLoading = true;
      try {
        const products = await UTDService.getProducts(this.page);
        this.products = products;
      } catch (e) {
        console.log(e);
      }
      this.isLoading = false;
    },
  },
  computed: {
    filteredProducts() {
      if (!this.filters.length) {
        return this.products;
      }

      return this.products.filter((prod) => {
        const lowerCaseCategories = prod.metadata.categories.map((c) => c.toLowerCase());
        return this.filters.every((selection) =>
          lowerCaseCategories.includes(selection.toLowerCase())
        );
      });
    },

    expandMobileFilter() {
      return this.getIsExpandedMobileFilter();
    },
  },

  watch: {
    page() {
      this.getProducts();
    },
  },

  mounted() {
    this.getProducts();
  },
};
</script>

<style lang="scss" scoped></style>
